module.exports = __webpack_public_path__ + "img/39.b7ae8c50.png";